import React from "react";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";

interface StatusStyle {
  backgroundColor: string;
  borderColor: string;
  color: string;
  width: string;
  display?: string;
  alignItems?: string;
  gap?: number;
}

interface StatusInfo {
  label: string;
  style: StatusStyle;
  icon?: React.ReactNode;
  translationKey?: string;
}

const getDeliveryStatusMap = (t: any): Record<string, StatusInfo> => ({
  pending: {
    label: "Pending delivery",
    translationKey: "orders.tag.pendingdelivery",
    style: {
      backgroundColor: "rgba(0, 44, 140, 1)",
      borderColor: "rgba(0, 44, 140, 1)",
      color: "rgba(255, 255, 255, 1)",
      width: "fit-content",
    },
  },
  preparing: {
    label: "Preparing Order",
    translationKey: "orders.tag.preparingorder",
    style: {
      backgroundColor: "rgba(9, 88, 217, 1)",
      borderColor: "rgba(0, 44, 140, 1)",
      color: "rgba(255, 255, 255, 1)",
      width: "fit-content",
    },
  },
  ready_to_deliver: {
    label: "Ready to deliver",
    translationKey: "orders.tag.readyToDeliver",
    style: {
      backgroundColor: "rgba(145, 202, 255, 1)",
      borderColor: "rgba(0, 44, 140, 1)",
      color: "rgba(0, 44, 140, 1)",
      width: "fit-content",
    },
  },
  in_transit: {
    label: "In Transit",
    translationKey: "orders.tag.intransit",
    style: {
      backgroundColor: "rgba(230, 244, 255, 1)",
      borderColor: "rgba(0, 44, 140, 1)",
      color: "rgba(0, 44, 140, 1)",
      width: "fit-content",
    },
  },
  delivered: {
    label: "Delivered",
    translationKey: "orders.tag.delivered",
    style: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "rgba(0, 44, 140, 1)",
      color: "rgba(0, 44, 140, 1)",
      width: "fit-content",
    },
  },
  pending_cancel: {
    label: t("button.table.linkedsellers.cancelrequest"),
    translationKey: "orders.tag.pendingcancel",
    style: {
      backgroundColor: "rgba(255, 77, 79, 1)",
      borderColor: "rgba(217, 54, 62, 1)",
      color: "rgba(255, 255, 255, 1)",
      width: "fit-content",
    },
  },
  pending_move: {
    label: t("orders.tag.pendingmove") || "Solicitud de movimiento",
    translationKey: "orders.tag.pendingmove",
    style: {
      backgroundColor: "rgba(250, 173, 20, 1)",
      borderColor: "rgba(212, 138, 0, 1)",
      color: "rgba(255, 255, 255, 1)",
      width: "fit-content",
    },
  },
  canceled: {
    label: "Canceled",
    translationKey: "orders.tag.canceled",
    style: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "rgba(217, 54, 62, 1)",
      color: "rgba(217, 54, 62, 1)",
      width: "fit-content",
    },
  },
});

interface StatusTagProps {
  status: string;
}

const StatusDeliveryTag: React.FC<StatusTagProps> = ({ status }) => {
  const { t } = useTranslation();
  const statusMap = getDeliveryStatusMap(t);
  const statusInfo = statusMap[status as keyof typeof statusMap];

  if (!statusInfo) {
    return <Tag color="default">Others</Tag>;
  }

  const label = statusInfo.translationKey
    ? t(statusInfo.translationKey)
    : statusInfo.label;

  return (
    <Tag style={statusInfo.style} icon={statusInfo.icon}>
      {label}
    </Tag>
  );
};

export default StatusDeliveryTag;
